package com.tedd.db

import kotlin.Long
import kotlin.String

public data class Timer_state(
  public val id: String,
  public val running: Long,
  public val started_at: Long?,
  public val planned_minutes: Long,
  public val item_id: String?,
  public val skill_id: String?,
  public val paused_at: Long?,
  public val paused_accum_ms: Long,
  public val device: String?,
  public val created_at: Long,
  public val updated_at: Long,
  public val is_deleted: Long,
  public val deleted_at: Long?,
  public val synced_at: Long?,
)
